import React from 'react'
import { Provider, defaultTheme } from '@adobe/react-spectrum'
import ErrorBoundary from 'react-error-boundary'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import { Home } from './Home'

function App (props) {
  props.runtime.on('configuration', ({ imsOrg, imsToken, locale }) => {
    console.log('configuration change', { imsOrg, imsToken, locale })
  })
  props.runtime.on('history', ({ type, path }) => {
    console.log('history change', { type, path })
  })

  return (
    <ErrorBoundary onError={() => {}} FallbackComponent={({ error }) => (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <h1>Something went wrong</h1>
        <pre>{error.message}</pre>
      </div>
    )}>
      <Provider theme={defaultTheme} colorScheme='light'>
        <Router>
          <Routes>
            <Route path='/' element={<Home runtime={props.runtime} ims={props.ims} />} />
          </Routes>
        </Router>
      </Provider>
    </ErrorBoundary>
  )
}

export default App
